import { render } from "./DetailList.vue?vue&type=template&id=09ee1201"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__